import ReactDOM from 'react-dom';
import React from 'react';

import App from './features/App/App';

import "./index.scss";


ReactDOM.render(<App />, document.getElementById('root'));
